"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const utils_1 = require("@osmosys/utils");
const lodash_1 = require("lodash");
const react_1 = tslib_1.__importDefault(require("react"));
const isValidUrl = (str) => {
    const pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
    return !!pattern.test(str);
};
exports.screenshot = ({ step, step: { linkSelector, linkToContentItem, linkToFirstLink, cssForImgTag, cssForATag, imgWidth, }, el, log, createScreenshot, parentTimestamp, linkToPost, }) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d;
    const tagJsx = react_1.default.createElement("code", null,
        "<",
        el.tagName.toLowerCase(),
        " />");
    // LOG
    let screenshotUrl;
    log('debug', {
        message: (react_1.default.createElement("span", { "data-osmosys-comp": "Converter.Screenshot.Loading" },
            "Taking screenshot of ",
            tagJsx,
            "...")),
        parentTimestamp,
        previewHtml: (_a = el) === null || _a === void 0 ? void 0 : _a.outerHTML,
    });
    try {
        screenshotUrl = yield createScreenshot((_b = el) === null || _b === void 0 ? void 0 : _b.outerHTML, step);
        log('debug', {
            message: react_1.default.createElement(react_1.default.Fragment, null,
                "Screenshot taken of ",
                tagJsx,
                "."),
            parentTimestamp,
        });
    }
    catch (e) {
        utils_1.logger.error({
            error: e,
            errorMessage: `${e}`,
            errorStack: e.stack,
        }, 'Failed to take screenshot');
        // LOG
        log('error', {
            message: react_1.default.createElement(react_1.default.Fragment, null,
                "Failed to take screenshot of ",
                tagJsx,
                "."),
            parentTimestamp,
        });
        return el;
    }
    if (!screenshotUrl) {
        // LOG
        log('error', {
            message: 'Screenshot was not taken.',
            parentTimestamp,
        });
        return el;
    }
    let link = linkToContentItem && isValidUrl(linkToPost) ? linkToPost : undefined;
    try {
        if (linkToFirstLink || linkSelector) {
            const eSandbox = document.createElement('div');
            eSandbox.innerHTML = el.outerHTML;
            if (linkToFirstLink) {
                log('debug', {
                    message: 'Looking for link for screenshotted element...',
                    parentTimestamp,
                });
                const firstLink = eSandbox.querySelector('a[href]');
                if (firstLink) {
                    link = firstLink.getAttribute('href');
                    log('debug', {
                        linkUrl: link,
                        message: `Linking screenshot to first link found in HTML of screenshot: ${lodash_1.truncate(link, {
                            length: 60,
                        })}`,
                        parentTimestamp,
                    });
                }
                else {
                    log('debug', {
                        message: 'No link found in HTML of screenshot.',
                        parentTimestamp,
                    });
                }
            }
            else if (linkSelector) {
                const attr = linkSelector.match(/\[([^(\]|[)]+)\]!$/im);
                const customAttr = attr && attr[1];
                const selectedLink = eSandbox.querySelector(linkSelector.replace(/!$/im, ''));
                if (selectedLink && selectedLink.hasAttribute(customAttr)) {
                    link = selectedLink.getAttribute(customAttr);
                    log('debug', {
                        linkUrl: link,
                        message: `Linking screenshot to first link found using selector: ${lodash_1.truncate(link, {
                            length: 60,
                        })} (custom link attribute: ${customAttr})`,
                        parentTimestamp,
                    });
                }
                else if (selectedLink && selectedLink.hasAttribute('href')) {
                    link = selectedLink.getAttribute('href');
                    log('debug', {
                        linkUrl: link,
                        message: `Linking screenshot to first link found using selector: ${lodash_1.truncate(link, {
                            length: 60,
                        })}`,
                        parentTimestamp,
                    });
                }
                else {
                    log('debug', {
                        message: 'No link found in HTML of screenshot.',
                        parentTimestamp,
                    });
                }
            }
        }
    }
    catch (e) {
        utils_1.logger.error({ error: e }, `${e}`);
        log('error', {
            message: 'Failed to get link for screenshot.',
            parentTimestamp,
        });
    }
    const newImg = document.createElement('img');
    const newA = document.createElement('a');
    try {
        newImg.setAttribute('src', screenshotUrl);
        newImg.setAttribute('class', 'osys-screenshot');
        if (cssForImgTag) {
            newImg.setAttribute('style', cssForImgTag);
        }
        if (imgWidth) {
            newImg.setAttribute('width', `${imgWidth}`);
        }
        if (link) {
            newA.setAttribute('class', 'osys-screenshot-link');
            newA.setAttribute('href', link);
            newA.appendChild(newImg);
            el.replaceWith(newA);
            if (cssForATag) {
                newA.setAttribute('style', cssForATag);
            }
        }
        else {
            el.replaceWith(newImg);
        }
    }
    catch (e) {
        utils_1.logger.error(e);
        // LOG
        log('error', {
            message: 'Screenshot was taken, but could not be placed into your HTML (1).',
            parentTimestamp,
        });
        return el;
    }
    log('success', {
        imageUrl: screenshotUrl,
        linkUrl: link,
        message: (react_1.default.createElement("span", { "data-osmosys-comp": "Converter.Screenshot.Success", style: { verticalAlign: 'middle' } }, "Screenshot succesfully taken.")),
        parentTimestamp,
        plainTextMessage: 'Screenshot succesfully taken.',
        previewHtml: link ? (_c = newA) === null || _c === void 0 ? void 0 : _c.outerHTML : (_d = newImg) === null || _d === void 0 ? void 0 : _d.outerHTML,
    });
    return el;
});
//# sourceMappingURL=screenshot.js.map